import { getClient } from "./client.js";

export interface FeedbackContext {
  masteryPreset?: string;
  activePlanTemplateId?: string;
  totalReviewed?: number;
  masteredCount?: number;
  accountAgeDays?: number;
  activeSkill?: string;
  sessionAccuracy?: number;
}

export interface FeedbackPayload {
  screen: string;
  loves?: string;
  hates?: string;
  wishes?: string;
  platform: "web" | "mobile";
  appVersion?: string;
  wantsFollowup?: boolean;
  context?: FeedbackContext;
}

/**
 * Submit qualitative feedback to Supabase.
 * No-op when Supabase is not configured.
 * Throws on insert error so callers can show an error state.
 */
export async function submitFeedback(payload: FeedbackPayload): Promise<void> {
  const supabase = getClient();
  if (!supabase) return;

  const userId = (await supabase.auth.getUser()).data.user?.id ?? null;

  const { error } = await supabase.from("feedback").insert({
    user_id: userId,
    screen: payload.screen,
    loves: payload.loves ?? null,
    hates: payload.hates ?? null,
    wishes: payload.wishes ?? null,
    platform: payload.platform,
    app_version: payload.appVersion ?? null,
    wants_followup: payload.wantsFollowup ?? false,
    context: payload.context ?? null,
    created_at: new Date().toISOString(),
  });

  if (error) throw new Error(error.message);
}
